import React, { createContext, useCallback, useContext } from 'react';
import { useMutableRef } from '@carnica/utils/hooks';
import { useAppDispatch, useAppSelector } from "../../../../../shared/model";
import { removeUnreadedMessage, selectUnreadedMessages } from "../../redux";
var UnreadedMessagesContext = /*#__PURE__*/createContext(function () {});
export var UnreadedMessagesProvider = function UnreadedMessagesProvider(_ref) {
  var children = _ref.children;
  var dispatch = useAppDispatch();
  var unreadedMessages = useMutableRef(useAppSelector(selectUnreadedMessages).map(function (_ref2) {
    var messageId = _ref2.messageId;
    return messageId;
  }));
  var onInView = useCallback(function (id) {
    if (unreadedMessages.current.includes(id)) {
      dispatch(removeUnreadedMessage(id));
    }
  }, []);
  return /*#__PURE__*/React.createElement(UnreadedMessagesContext.Provider, {
    value: onInView
  }, children);
};
export var useUnreadedMessagesContext = function useUnreadedMessagesContext() {
  return useContext(UnreadedMessagesContext);
};